import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const OptionalServicesWrapper = styled.div`
  &&& {
    padding-top: ${pxToRem(24)};
  }
`;

export const OptionalServicesTitle = styled.div<{
  $isOpen: boolean;
}>`
  &&& {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${pxToRem(16)};
    ${(props) =>
      props.$isOpen &&
      css`
        border-bottom: ${pxToRem(1)} solid ${props.theme.colors.background3};
      `}
  }
`;

export const SelectedSection = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: ${pxToRem(16)};
    justify-content: flex-end;
  }
`;

export const TextSelectionWrapper = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: ${pxToRem(8)};
  }
`;

export const OptionalServicesListWrapper = styled.div`
  &&& {
    padding-top: ${pxToRem(16)};
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(16)};
  }
`;

export const OptionalServicesItemWrapper = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: ${pxToRem(16)};
  }
`;

export const OptionalServicesItemTitle = styled.div`
  &&& {
    flex: 1;
  }
`;
